export default "__VITE_ASSET__1_oHqG09__";